import React, { useState, useEffect } from 'react'
import { encodeForURL } from '../../../../global/formatters/string-formatter.js'
import { getRelativeBasePath } from '../../../../global/environments/path.js'
import { getAuthManagerInstance } from '../../../../global/authentication/authentication-manager.js'
import { postNoAddressChange } from '../../Data/LoginDatasource.js'

export default function EmailChange() {
  const [email, setEmail] = useState()
  const [selectedOption, setSelectedOption] = useState('changed-new')

  useEffect(() => {
    getAuthManagerInstance()
      .getProfileServiceBehaviorSubject()
      .subscribe((profile) => {
        if (profile) {
          setEmail(profile.emailId)
        }
      })
  }, [])

  const validInputs = ['changed-new', 'changed-else', 'changed-none']

  const onChange = (event) => {
    setSelectedOption(event.target.value)
  }

  const onClick = async () => {
    const acceptableInput = validInputs.includes(selectedOption)
    if (acceptableInput && selectedOption !== 'changed-none') {
      window.location.href =
        getRelativeBasePath() + '/register?user=' + encodeForURL(selectedOption)
    } else {
      const data = {
        newFirmId: email,
      }
      await postNoAddressChange(data)
      window.location.href = getRelativeBasePath() + '/'
    }
  }

  return (
    <div className="login-scope investment-products">
      <div className="u-sizeConstrained">
        <div className="Card Content u-paddingTop10gu u-paddingHoriz6gu u-marginVert10gu u-bgColorLightest">
          <div className="u-paddingHoriz6gu u-marginBottom5gu">
            <h2>Has Your Email Address Changed?</h2>
          </div>
          <div className="u-paddingHoriz6gu">
            <div className="Radio u-posRelative">
              <input
                className="Radio-button"
                id="role1"
                type="radio"
                name="role"
                value="changed-new"
                checked={selectedOption === 'changed-new'}
                onChange={onChange}
              />
              <label
                className="Radio-label u-marginBottom4gu"
                htmlFor="role1"
                style={{ cursor: 'pointer' }}
              >
                My email address changed to {email}
              </label>
            </div>
            <div className="Radio u-posRelative">
              <input
                className="Radio-button"
                id="role2"
                type="radio"
                name="role"
                value="changed-else"
                checked={selectedOption === 'changed-else'}
                onChange={onChange}
              />
              <label
                htmlFor="role2"
                className="Radio-label u-marginBottom4gu"
                style={{ cursor: 'pointer' }}
              >
                My email address changed to something else
              </label>
            </div>
            <div className="Radio u-posRelative">
              <input
                className="Radio-button"
                id="role3"
                type="radio"
                name="role"
                value="changed-none"
                checked={selectedOption === 'changed-none'}
                onChange={onChange}
              />
              <label
                htmlFor="role3"
                className="Radio-label u-marginBottom4gu"
                style={{ cursor: 'pointer' }}
              >
                My email address has not changed
              </label>
            </div>
          </div>
          <div className="u-flex u-flexAlignItemsCenter u-flexJustifyEnd u-paddingHoriz6gu u-marginVert4gu u-textNoTransform">
            <button
              className="Button Button--primary u-paddingHoriz10gu u-textNoTransform"
              onClick={onClick}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
